import { Component, input, output } from '@angular/core';

import { SupportedThemesT } from '@recruitee/theme';
import { IconButtonComponent } from '@recruitee/user-interface';

import { KiwiHrPromoComponent } from '../kiwi-hr-promo/kiwi-hr-promo.component';

@Component({
  selector: 'rti-kiwi-hr-promo-dashboard',
  templateUrl: './kiwi-hr-promo-dashboard.component.html',
  styleUrls: ['./kiwi-hr-promo-dashboard.component.less'],
  standalone: true,
  imports: [IconButtonComponent, KiwiHrPromoComponent],
})
export class KiwiHrPromoDashboardComponent {
  protected theme = input.required<SupportedThemesT>();
  protected close = output();
  protected ctaClick = output();
}
